import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Guides from './pages/Guides';
import GuideDetail from './pages/GuideDetail';
import Finder from './pages/Finder';
import Resources from './pages/Resources';
import Universities from './pages/Universities';
import Checklist from './pages/Checklist';
import Glossary from './pages/Glossary';
import Calendar from './pages/Calendar';
import Compare from './pages/Compare';
import Alerts from './pages/Alerts';
import SeasonPass from './pages/SeasonPass';
import About from './pages/About';
import Consulting from './pages/Consulting';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import CourseForm from './pages/CourseForm';
import LearningPage from './pages/LearningPage';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Analytics } from '@vercel/analytics/react';
import KakaoCallback from './pages/KakaoCallback';
import NaverCallback from './pages/NaverCallback';

// 어드민 라우트 컴포넌트 - 어드민 권한 확인
const AdminRoute = ({ children }) => {
  return (
    <PrivateRoute>
      {children}
    </PrivateRoute>
  );
};

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/guides" element={<Guides />} />
                <Route path="/guides/:guideId" element={<GuideDetail />} />
                <Route path="/finder" element={<Finder />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/universities" element={<Universities />} />
                <Route path="/checklist" element={<Checklist />} />
                <Route path="/glossary" element={<Glossary />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/pass" element={<SeasonPass />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/courses/:courseId" element={<CourseDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/consulting" element={<Consulting />} />
                <Route path="/contact" element={<Navigate to="/consulting" replace />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/refund" element={<Refund />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/verify-email/:token" element={<VerifyEmail />} />
                <Route path="/dashboard" element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } />
                <Route path="/learning/:courseId" element={
                  <PrivateRoute>
                    <LearningPage />
                  </PrivateRoute>
                } />
                
                {/* 어드민 라우트 */}
                <Route path="/admin" element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                } />
                <Route path="/admin/courses/new" element={
                  <AdminRoute>
                    <CourseForm />
                  </AdminRoute>
                } />
                <Route path="/admin/courses/edit/:id" element={
                  <AdminRoute>
                    <CourseForm />
                  </AdminRoute>
                } />
                <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
                <Route path="/auth/naver/callback" element={<NaverCallback />} />
              </Routes>
            </main>
            <Footer />
            <Analytics />
          </div>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
